import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreListComponent } from './store-list/store-list.component';
import {StoresRoutingModule} from '@app/marketplace/stores/stores-routing.module';
import {NgbDropdownModule, NgbNavModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from '@app/marketplace/shared/shared.module';
import {StoreModule} from '@ngrx/store';
import {STORE_FEATURE_KEY, featuresReducers} from '@app/marketplace/app.state';
import {EffectsModule} from '@ngrx/effects';
import {StoresEffects} from '@app/marketplace/stores/state/store/stores-effects';
import {FormsModule} from '@angular/forms';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {StoreDetailsComponent} from '@app/marketplace/stores/store-details/store-details.component';
import {StoreDetailsEffects} from '@app/marketplace/stores/state/store-details/store-details-effects';

@NgModule({
  declarations: [
    StoreListComponent,
    StoreDetailsComponent
  ],
  imports: [
    CommonModule,
    NgbNavModule,
    StoresRoutingModule,
    StoreModule.forFeature(STORE_FEATURE_KEY, featuresReducers),
    EffectsModule.forFeature([StoresEffects, StoreDetailsEffects]),
    SharedModule,
    FormsModule,
    NgbPaginationModule,
    NgxSkeletonLoaderModule
  ]
})
export class StoresModule { }
